<template>
  <div class="reporting management-page">
    <div class="title">Risk Information</div>

    <!-- Bootstrap Tabs -->
    <ul class="nav nav-tabs" id="billingTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link active" id="bill-details-tab" data-bs-toggle="tab" href="#bill-details" role="tab" aria-controls="bill-details" aria-selected="true">3x Std Dev</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="rolling-billing-tab" data-bs-toggle="tab" href="#rolling-billing" role="tab" aria-controls="rolling-billing" aria-selected="false" @click="rollingBillingHack">Over High Ticket</a>
      </li>
      <!-- NEW TAB FOR HIGH VELOCITY -->
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="velocity-tab" data-bs-toggle="tab" href="#velocity-tab-pane"
           role="tab" aria-controls="velocity-tab-pane" aria-selected="false" @click="velocityHack">
          High Velocity
        </a>
      </li>
      <!-- NEW TAB FOR MERCHANT FREEZE -->
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="merchant-freeze-tab" data-bs-toggle="tab" href="#merchant-freeze-pane"
           role="tab" aria-controls="merchant-freeze-pane" aria-selected="false" @click="loadMerchants">
          Merchant Control
        </a>
      </li>
    </ul>

    <div class="tab-content" id="billingTabContent">
      <div class="tab-pane fade show active" id="bill-details" role="tabpanel" aria-labelledby="bill-details-tab">
        <ag-grid
          ref="agRef"
          :define-defs="lineItemColDefs"
          group-panel=""
          :excel-options="{ fileName: 'StandardDeviations.xlsx' }"
          height="500px"
          :columns="[]"
          :side-bar="true"
        >
        </ag-grid>
      </div>

      <div class="tab-pane fade" id="rolling-billing" role="tabpanel" aria-labelledby="rolling-billing-tab">
        <ag-grid
          ref="agRefRolling"
          :apiurl="() => []"
          :define-defs="rollingColDefs"
          group-panel=""
          :excel-options="{ fileName: 'OverHighTicketLimit.xlsx' }"
          height="500px"
          :columns="[]"
          :side-bar="true"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid>
      </div>

      <!-- NEW TAB PANE FOR HIGH VELOCITY -->
      <div class="tab-pane fade" id="velocity-tab-pane" role="tabpanel" aria-labelledby="velocity-tab">
        <ag-grid
          ref="agRefVelocity"
          :apiurl="() => []"
          :define-defs="velocityColDefs"
          group-panel=""
          :excel-options="{ fileName: 'HighVelocity.xlsx' }"
          height="500px"
          :columns="[]"
          :side-bar="true"
          @first-data-rendered="onVelocityDataRendered"
        >
        </ag-grid>
      </div>

      <!-- NEW TAB PANE FOR MERCHANT FREEZE -->
      <div class="tab-pane fade" id="merchant-freeze-pane" role="tabpanel" aria-labelledby="merchant-freeze-tab">
        <div class="merchant-freeze-container p-4">
          <div class="card">
            <div class="card-header bg-light">
              <h5 class="mb-0">Merchant Transaction Control</h5>
            </div>
            <div class="card-body">
              <div class="row mb-4">
                <div class="col-md-6">
                  <label for="merchantSelect" class="form-label">Select Merchant</label>
                  <select
                    id="merchantSelect"
                    v-model="selectedMerchantId"
                    class="form-select"
                    @change="checkMerchantStatus"
                  >
                    <option value="">-- Select a Merchant --</option>
                    <option
                      v-for="merchant in merchantOptions"
                      :key="merchant.id"
                      :value="merchant.id"
                    >
                      {{ merchant.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Current Status</label>
                  <div>
                    <span
                      class="status-badge"
                      :class="{'status-active': isMerchantActive, 'status-frozen': !isMerchantActive}"
                    >
                      {{ isMerchantActive ? 'Active' : 'Frozen' }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <button
                    class="btn"
                    :class="isMerchantActive ? 'btn-danger' : 'btn-success'"
                    @click="toggleMerchantStatus"
                    :disabled="!selectedMerchantId || isProcessing"
                  >
                    <span v-if="isProcessing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isMerchantActive ? 'Freeze Transactions' : 'Enable Transactions' }}
                  </button>
                </div>
              </div>

              <!-- Confirmation modal -->
              <div class="alert alert-warning mt-4" v-if="showConfirmation">
                <h5>Confirm Action</h5>
                <p>
                  Are you sure you want to {{ isMerchantActive ? 'freeze' : 'enable' }} transactions for <strong>{{ selectedMerchantName }}</strong>?
                </p>
                <p v-if="isMerchantActive" class="text-danger">
                  <strong>Warning:</strong> Freezing transactions will prevent the merchant from processing any new transactions.
                </p>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-secondary me-2" @click="showConfirmation = false">Cancel</button>
                  <button
                    class="btn"
                    :class="isMerchantActive ? 'btn-danger' : 'btn-success'"
                    @click="confirmToggleStatus"
                    :disabled="isProcessing"
                  >
                    <span v-if="isProcessing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Confirm
                  </button>
                </div>
              </div>

              <!-- Status table -->
              <div class="merchant-status-table mt-5" v-if="merchantStatusHistory.length > 0">
                <h5 class="mb-3">Status Change History</h5>
                <table class="table table-bordered table-striped">
                  <thead class="table-light">
                  <tr>
                    <th>Merchant</th>
                    <th>Status</th>
                    <th>Changed By</th>
                    <th>Date/Time</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(entry, index) in merchantStatusHistory" :key="index">
                    <td>{{ entry.merchantName }}</td>
                    <td>
                        <span
                          class="status-badge"
                          :class="{'status-active': entry.status === 'Active', 'status-frozen': entry.status === 'Frozen'}"
                        >
                          {{ entry.status }}
                        </span>
                    </td>
                    <td>{{ entry.changedBy }}</td>
                    <td>{{ formatDateTime(entry.timestamp) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transaction Notes Dialog -->
    <transaction-notes-dialog
      :show="showNotesDialog"
      :transaction-id="selectedTransactionId"
      @close="closeNotesDialog"
      @note-added="refreshData"
    />
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch } from 'vue';
import AgGrid from '@/components/AgGrid.vue';
import TransactionNotesDialog from '@/components/TransactionNotesDialog.vue';
import http from '@/services/http';

// --------------------------------------------------
// Refs for the existing tabs
// --------------------------------------------------
const agRef = ref();          // 3x Std Dev
const agRefRolling = ref();   // Over High Ticket

// --------------------------------------------------
// Refs for the NEW High Velocity tab
// --------------------------------------------------
const agRefVelocity = ref();        // Reference to the grid for High Velocity
const velocityData = ref([]);       // Data for the High Velocity grid

// Existing refs for the other two tables
const billDetailsData = ref([]);
const rollingBillingData = ref([]);

// Dialog state
const showNotesDialog = ref(false);
const selectedTransactionId = ref('');

// --------------------------------------------------
// Refs for the NEW Merchant Freeze tab
// --------------------------------------------------
const merchantOptions = ref([]);
const selectedMerchantId = ref('');
const selectedMerchantName = ref('');
const isMerchantActive = ref(true);  // changed from isMerchantFrozen to isMerchantActive to match backend
const isProcessing = ref(false);
const showConfirmation = ref(false);
const merchantStatusHistory = ref([]);

// Watchers to update row data on changes
watch([billDetailsData, agRef], () => {
  if (!billDetailsData.value) return;
  agRef.value?.setTheRowData(billDetailsData.value);
});

watch([rollingBillingData, agRefRolling], () => {
  if (!rollingBillingData.value) return;
  agRefRolling.value?.setTheRowData(rollingBillingData.value);
});

// WATCH FOR THE NEW VELOCITY DATA
watch([velocityData, agRefVelocity], () => {
  if (!velocityData.value) return;
  agRefVelocity.value?.setTheRowData(velocityData.value);
});

// Watch for merchant selection changes
watch(selectedMerchantId, (newVal) => {
  if (newVal) {
    // Find the merchant name from the options
    const merchant = merchantOptions.value.find(m => m.id === newVal);
    if (merchant) {
      selectedMerchantName.value = merchant.name;
    }
  } else {
    selectedMerchantName.value = '';
  }
});

// On mounted, fetch data and populate tables
onMounted(async () => {
  await fetchData();
});

// Fetch all data from the API
async function fetchData() {
  try {
    const response = await http.get(`/api/transaction-monitoring`);
    const message = response.data.message;

    // Table #1: 3x Std Dev
    billDetailsData.value = message.standard_deviation_list;
    agRef?.value?.setTheRowData(billDetailsData.value);
    agRef?.value?.setTheColumnDefs(columnDefinitionsBillDetails);

    // Table #2: Over High Ticket
    rollingBillingData.value = message.transactions_over_high_ticket_limit;
    agRefRolling?.value?.setTheRowData(rollingBillingData.value);
    agRefRolling?.value?.setTheColumnDefs(columnDefinitionsRollingBilling);

    // TABLE #3: HIGH VELOCITY
    velocityData.value = message.transactions_high_velocity;
    agRefVelocity?.value?.setTheRowData(velocityData.value);
    agRefVelocity?.value?.setTheColumnDefs(columnDefinitionsVelocity);
  } catch (error) {
    console.error('Failed to fetch data', error);
  }
}

// Load merchants for the dropdown
async function loadMerchants() {
  try {
    const response = await http.get('/api/merchant-names');
    const merchantNames = response.data.message.merchant_names;

    // Format merchant data for dropdown
    merchantOptions.value = merchantNames.map(merchant => {
      const [id, name] = Object.entries(merchant)[0];
      return { id, name };
    });

    // Load merchant status history
    await loadMerchantStatusHistory();
  } catch (error) {
    console.error('Failed to load merchants', error);
  }
}

// Check merchant status
async function checkMerchantStatus() {
  if (!selectedMerchantId.value) return;

  try {
    isProcessing.value = true;
    const response = await http.get(`/api/merchant-status/${selectedMerchantId.value}`);
    isMerchantActive.value = response.data.message.is_active; // This is now "is_active" instead of "is_frozen"
    console.log('Merchant status updated:', isMerchantActive.value ? 'Active' : 'Frozen');
  } catch (error) {
    console.error('Failed to check merchant status', error);
  } finally {
    isProcessing.value = false;
  }
}

// Show confirmation dialog before toggling status
function toggleMerchantStatus() {
  showConfirmation.value = true;
}

// Actually toggle the merchant status
async function confirmToggleStatus() {
  if (!selectedMerchantId.value) return;

  try {
    isProcessing.value = true;
    // Action is now freeze when active, unfreeze when inactive
    const action = isMerchantActive.value ? 'freeze' : 'unfreeze';

    const response = await http.post(`/api/merchant-status/${selectedMerchantId.value}/${action}`);

    if (response.data.success) {
      // Instead of manually toggling, fetch fresh status from server
      await checkMerchantStatus();

      // Add to status history - Note: we use the updated isMerchantActive value now
      merchantStatusHistory.value.unshift({
        merchantId: selectedMerchantId.value,
        merchantName: selectedMerchantName.value,
        status: isMerchantActive.value ? 'Active' : 'Frozen',
        changedBy: 'Current User', // You might want to get the actual username from your auth system
        timestamp: new Date().toISOString()
      });

      // Show success message
      alert(`Merchant ${isMerchantActive.value ? 'activated' : 'frozen'} successfully`);
    }
  } catch (error) {
    console.error('Failed to toggle merchant status', error);
    alert(`Error: ${error.response?.data?.message || 'Failed to update merchant status'}`);

    // If there's an error, refresh the status to be sure
    await checkMerchantStatus();
  } finally {
    isProcessing.value = false;
    showConfirmation.value = false;
  }
}

// Load merchant status history
async function loadMerchantStatusHistory() {
  try {
    const response = await http.get('/api/merchant-status/history');
    merchantStatusHistory.value = response.data.message.history || [];
  } catch (error) {
    console.error('Failed to load merchant status history', error);
  }
}

// Format date for display
function formatDateTime(isoString) {
  if (!isoString) return 'N/A';

  const date = new Date(isoString);
  return date.toLocaleString();
}

// Refresh data (called after adding a note)
function refreshData() {
  fetchData();
}

// Close notes dialog
function closeNotesDialog() {
  showNotesDialog.value = false;
  selectedTransactionId.value = '';
}

// --------------------------------------------------
// Column definitions for table #1: 3x Std Dev
// --------------------------------------------------
const columnDefinitionsBillDetails = [
  { headerName: 'Merchant', field: 'merchant' },
  { headerName: 'Transaction Id', field: 'transaction_id' },
  {
    headerName: 'Amount',
    field: 'amount',
    valueFormatter: params => parseFloat(params.value).toFixed(2),
  },
  {
    headerName: 'Average',
    field: 'avg_amount',
    valueFormatter: params => parseFloat(params.value).toFixed(2),
  },
  { headerName: 'Created At', field: 'created_at', sort: 'desc' },
  {
    headerName: 'Notes',
    field: 'has_notes',
    width: 100,
    valueFormatter: params => params.value ? 'Yes' : 'No',
    cellClass: params => params.value ? 'has-notes' : ''
  },
  {
    headerName: 'Actions',
    field: 'actions',
    width: 120,
    cellRenderer: (params) => {
      return `<p style="font-size: 12px; text-decoration: underline; cursor: pointer; color: #007bff;">View/Add Notes</p>`;
    },
    onCellClicked: (params) => {
      console.log('StdDev action clicked:', params.data);
      selectedTransactionId.value = params.data.transaction_id;
      showNotesDialog.value = true;
    },
    sortable: false,
    filter: false,
  }
];

const lineItemColDefs = computed(() => {
  return columnDefinitionsBillDetails;
});

// --------------------------------------------------
// Column definitions for table #2: Over High Ticket
// --------------------------------------------------
const columnDefinitionsRollingBilling = [
  { headerName: 'Merchant', field: 'name' },
  { headerName: 'Transaction Id', field: 'id' },
  { headerName: 'Processing Date', field: 'created_at' },
  {
    headerName: 'High Ticket Limit',
    field: 'limits_high_ticket',
    valueFormatter: params => parseFloat(params.value).toFixed(2),
  },
  {
    headerName: 'Amount',
    field: 'amount',
    valueFormatter: params => parseFloat(params.value).toFixed(2),
  },
  {
    headerName: 'Notes',
    field: 'has_notes',
    width: 100,
    valueFormatter: params => params.value ? 'Yes' : 'No',
    cellClass: params => params.value ? 'has-notes' : ''
  },
  {
    headerName: 'Actions',
    field: 'actions',
    width: 120,
    cellRenderer: (params) => {
      return `<p style="font-size: 12px; text-decoration: underline; cursor: pointer; color: #007bff;">View/Add Notes</p>`;
    },
    onCellClicked: (params) => {
      console.log('HighTicket action clicked:', params.data);
      selectedTransactionId.value = params.data.id;
      showNotesDialog.value = true;
    },
    sortable: false,
    filter: false,
  }
];

const rollingColDefs = computed(() => {
  return columnDefinitionsRollingBilling;
});

// --------------------------------------------------
// NEW: Column definitions for table #3: High Velocity
// --------------------------------------------------
const columnDefinitionsVelocity = [
  { headerName: 'Merchant', field: 'name' },
  { headerName: 'Transaction Id', field: 'id' },
  {
    headerName: 'Amount',
    field: 'amount',
    valueFormatter: params => parseFloat(params.value).toFixed(2),
  },
  { headerName: 'Created At', field: 'created_at' },
  { headerName: 'Velocity Risk', field: 'risk_velocity' },
  {
    headerName: 'Hourly Velocity Limit',
    field: 'limits_hourly_velocity',
    valueFormatter: params => params.value ?? '',
  },
  {
    headerName: 'Notes',
    field: 'has_notes',
    width: 100,
    valueFormatter: params => params.value ? 'Yes' : 'No',
    cellClass: params => params.value ? 'has-notes' : ''
  },
  {
    headerName: 'Actions',
    field: 'actions',
    width: 120,
    cellRenderer: (params) => {
      return `<p style="font-size: 12px; text-decoration: underline; cursor: pointer; color: #007bff;">View/Add Notes</p>`;
    },
    onCellClicked: (params) => {
      console.log('Velocity action clicked:', params.data);
      selectedTransactionId.value = params.data.id;
      showNotesDialog.value = true;
    },
    sortable: false,
    filter: false,
  }
];

const velocityColDefs = computed(() => {
  return columnDefinitionsVelocity;
});

// Grid ready function for Over High Ticket
const onFirstDataRendered = (params) => {
  console.log('onFirstDataRendered');
  params.api.sizeColumnsToFit();
  params.api.refreshCells({ force: true });
};

// Grid ready function for High Velocity
const onVelocityDataRendered = (params) => {
  console.log('onVelocityDataRendered');
  params.api.sizeColumnsToFit();
  params.api.refreshCells({ force: true });
}

// For Over High Ticket tab
let rollingBillingHackRan = false;
function rollingBillingHack() {
  if (rollingBillingHackRan) return;
  setTimeout(() => agRefRolling.value.resetState(), 100);
  setTimeout(() => agRef.value.resetState(), 100);
  rollingBillingHackRan = true;
}

// For High Velocity tab
let velocityHackRan = false;
function velocityHack() {
  if (velocityHackRan) return;
  setTimeout(() => agRefVelocity.value.resetState(), 100);
  setTimeout(() => agRef.value.resetState(), 100);
  velocityHackRan = true;
}
</script>

<style lang="scss" scoped>
.management-page {
  padding: 20px;
  background-color: #f8f9fa;

  .title {
    color: #343a40;
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .nav-tabs {
    border-bottom: 2px solid #dee2e6;
  }

  .nav-item .nav-link {
    color: #495057;
    font-size: 16px;
    padding: 10px 20px;
    border-radius: 0 !important;
  }

  .nav-item .nav-link.active {
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
    font-weight: 600;
    color: #007bff;
  }

  .table {
    margin-top: 20px;
    height: 60vh;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: #fff;
  }

  .refresh-text {
    font-size: 18px;
    color: #495057;
    font-weight: 600;
    margin-top: 10px;
    display: inline-block;
  }

  .subs-btn {
    height: 40px;
    background: #007bff !important;
    border-color: #007bff !important;
    color: #fff !important;
    border-radius: 4px;
    transition: background 0.3s;

    &:hover {
      background: #0056b3 !important;
    }
  }

  // Status badges
  .status-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 1rem;
    font-weight: 600;
    text-align: center;
    min-width: 80px;
  }

  .status-active {
    background-color: #d4edda;
    color: #155724;
  }

  .status-frozen {
    background-color: #f8d7da;
    color: #721c24;
  }

  .merchant-freeze-container {
    height: 500px;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    padding: 10px;

    .title {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .nav-item .nav-link {
      font-size: 14px;
    }

    .table {
      height: 50vh;
    }
  }
}

/* ag-grid theme overrides */
.ag-theme-alpine {
  --ag-header-background-color: #f1f3f5;
  --ag-row-hover-color: #f8f9fa;
  --ag-header-cell-text-color: #343a40;
  --ag-odd-row-background-color: #fff;
  --ag-header-font-weight: 600;
}

/* Style for cells that have notes */
:deep(.has-notes) {
  color: #007bff;
  font-weight: 600;
}

:deep(.ag-row:hover) {
  background-color: rgba(0, 123, 255, 0.1) !important;
}
</style>